import { Typography } from "@packages/ds";
import styled from "styled-components";

export const RoutesDescriptionRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-block: 16px;
`;

export const Code = styled(Typography.Code)`
  margin: unset;
`;
